module.exports = __webpack_public_path__ + "static/img/cont2602.b145a89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2602.jpg
// module id = Em0u
// module chunks = 0